import API from "~/config/api";
import fetchJson from "~/utils/Fetch/json";

export const validate = async () => {
  const resp = await fetchJson(
    "/api/next/agent/validate",
    API.POST_CONFIG({})
  ).catch((error) => {
    return error;
  });

  const user = resp.data?.user;
  if (!user?.isLoggedIn) return user;

  const crmDomain = process.env.NEXT_PUBLIC_CRM_DOMAIN;
  const statusResp = await fetch(new URL('session/status', crmDomain), {
    method: 'GET',
    credentials: 'include',
  }).catch(() => null);

  if (!statusResp?.ok) {
    fetch('/api/next/agent/reset-session').catch(() => {});
    return { ...user, isLoggedIn: false };
  }

  return user;
};
